<template>
  <div>
    <div v-for="(product_group, product_name) in groupedBillingPlans" :key="product_name">
      <vertical-expander>
        <template v-slot:title>
          <p class="m-b-xs m-t-sm">{{ product_name }}</p>
        </template>
        <template v-slot:content>
          <div class="grid grid-cols-1 gap-y-xs">
            <div v-for="billing_plan in product_group" :key="billing_plan.id" class="flex flex-col bg-white rounded p-xs">
              <div>
                <p class="m-b-none text-sm font-semi" :title="billing_plan.name">{{ billing_plan.name }}</p>
              </div>
              <div class="flex flex-col gap-y-xs m-t-xs">
                <div class="flex gap-x-xs align-items-center">
                  <wrestler-icon stroke-color="text-gray-700"></wrestler-icon>
                  <span class="text-gray-600">{{ billing_plan.max_wrestler_count }} wrestler limit</span>
                </div>
                <div class="flex gap-x-xs align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6 text-gray-600">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                  </svg>
                  <span class="text-gray-600 text-sm">{{ formatAsCurrency(billing_plan.amount) }} per wrestler/hour</span>
                </div>
                <div class="flex gap-x-xs align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6 text-gray-600">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                  <span class="text-gray-600 text-sm">{{ formatAsCurrency(billing_plan.facility_price_per_hour) }} facility fee/hour</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </vertical-expander>
    </div>
  </div>
</template>

<script>
import { currencyMix } from '../../shared/currency_mix';
import WrestlerIcon from '../../shared/wrestler-icon.vue';
import VerticalExpander from './vertical_expander.vue';

export default {
  components: {
    WrestlerIcon,
    VerticalExpander
  },
  mixins: [currencyMix],
  props: {
    billingPlans: {
      type: Array,
      required: true
    }
  },
  computed: {
    groupedBillingPlans() {
      if (!this.billingPlans) return {};
      
      let groups = {};
      this.billingPlans.forEach(plan => {
        const productName = plan.product ? plan.product.name : 'Other';
        if (!groups[productName]) {
          groups[productName] = [];
        }
        groups[productName].push(plan);
      });
      return groups;
    }
  }
};
</script> 